module.exports = __webpack_public_path__ + "img/grade22.6dd1bc23.png";